<template>
  <el-row :gutter="10">
    <el-col :xl="24" :lg="24" :md="24" :sm="24">
      <div class="searchForm" :class="showLabel ? 'p-sm-3 mt-2' : ''">
        <label for="search" v-if="showLabel">اختر اسم المورد</label>
        <el-row :gutter="10">
          <el-col
            :xl="24"
            :lg="24"
            :md="24"
            :sm="24"
          >
            <input
              @focus="resetSearch"
              type="text"
              class="form-control"
              readonly
              v-model="placeholder"
              id=""
              v-if="selectedSupplier"
            />
            <el-select
              v-else
              @change="supplierSelected"
              class="search supplierQuery"
              @focus="options = []"
              v-model="value"
              :loading-text="loadingMsg"
              :no-data-text="noDataMsg"
              filterable
              popper-class="searchDropdown"
              remote
              :clearable="true"
              :placeholder="placeholder"
              :remote-method="remoteMethod"
              :loading="loading"
            >
              <el-option
                ref="supplierQuery"
                v-for="item in options"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
                <span style="float: right">
                  {{ item.name }} - {{ item.address }}</span
                >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import axiosApi from "@/plugins/axios.js";

export default {
  name: "Searchsuppliers",
  props: [
    "productsLength",
    "supplier",
    "productSearch",
    "searchOnly",
    "showLabel",
    "useParcode",
  ],

  data() {
    return {
      index: 1,
      selectedLabel: "",
      noDataMsg: "لا توجد بيانات متاحه",
      loadingMsg: " ... جاري تحميل البيانات",
      options: [],
      value: null,
      loading: false,
      placeholder: this.supplier ? this.supplier.name : "بحث الموردين",
      selectedSupplier: this.supplier,
      supplierAccount: this.supplier
        ? this.supplier.balance + Number(this.supplier.account)
        : 0,
      addFormVisible: false,
      addsupplier: false,
      supplierForm: {
        name: "",
        type: 1,
        inventory_id: 1,
        area: 1,
        phone: "",
        account: 0,
        address: "",
      },
    };
  },
  mounted() {
    if (this.selectedSupplier) {
      this.placeholder = this.selectedSupplier.name;
    }
    if (this.$route.name != "ReturnPurchase") {
      this.addsupplier = true;
    }
    if (this.selectedSupplier) {
      document.querySelector(".productQuery input").focus();
    } else {
      document.querySelector(".supplierQuery input").focus();
    }
  },
  methods: {
    setValue(value) {
      this.selectedSupplier = value;
      this.value = value;
      if (this.value != null) {
        this.placeholder = value.name;
        this.supplierAccount = value.balance + Number(value.account);
      } else {
        this.placeholder = "";
      }
      if (!this.value) {
        setTimeout(() => {
          document.querySelector(".supplierQuery input").focus();
        }, 100);
      }
    },
    resetSearch() {
      if (this.productsLength == 0) {
        this.setValue(null);
        this.$emit("selectedSupplier", {
          supplier: null,
        });
      }
    },
    supplierSelected() {
      this.selectedSupplier = this.options.filter((supplier) => {
        if (supplier.id == this.value) {
          return supplier;
        }
      })[0];
      if (this.selectedSupplier) {
        this.placeholder = this.selectedSupplier.name;
        this.supplierAccount =
          this.selectedSupplier.balance + Number(this.selectedSupplier.account);
      }
      this.$emit("selectedSupplier", {
        supplier: this.selectedSupplier,
      });
    },
    remoteMethod(query) {
      if (query !== "") {
        this.selectedLabel = query;
        this.loading = true;
        axiosApi
          .get(`suppliers/search?query=${query}`)
          .then((res) => {
            this.loading = false;
            this.options = res.data;
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
          });
      } else {
        this.options = [];
      }
    },
  },
};
</script>
